exports.getQueryParams = (search) => {
  const result = {};
  const params = search.substr(1);
  const queryParamArray = params.split('&');
  queryParamArray.forEach((queryParam) => {
    const item = queryParam.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}


// WEBPACK FOOTER //
// ./src/helpers/commonHelper.js